import { FormSectionHandler } from '../entity.handler';
import { DeviceConfigProfileResponse, DeviceConfigProfileUpdateRequest, IdName } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField, FormBuilderKeyValue } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, ComboField, IdNameComboValueHandlers } from '../utils';
import { ICONS } from '../icons';
import { DeviceDetailsSectionHandler } from '../device/details.section';

interface EditorValues {
    name?: string;
    deviceType?: IdName;
}

export class DeviceConfigProfileDetailsSectionHandler implements FormSectionHandler<DeviceConfigProfileResponse, EditorValues> {

    type = 'form';
    icon = ICONS.deviceconfigprofile;
    bulk = false;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    private properties = ['name', 'deviceType', 'provider'];

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        private creating: boolean
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.DEVICECONFIGPROFILE.DETAILS.${key}`, values);
    }

    applyUpdate(entity: DeviceConfigProfileResponse, payload: DeviceConfigProfileUpdateRequest): Promise<DeviceConfigProfileResponse> {
        return this.admin.applyUpdate(api => api.entities.updateDeviceConfigProfile(entity.id, payload));
    }

    mapEntityToEditor(entity: DeviceConfigProfileResponse): Promise<EditorValues> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: DeviceConfigProfileResponse, values: EditorValues): Promise<DeviceConfigProfileUpdateRequest> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, values, entity));
    }

    async getFields(entity: DeviceConfigProfileResponse): Promise<FormBuilderField[]> {
        const company = await this.admin.getCached(`getCompany/${this.ownerId}`, api => api.accounts.getCompany(this.ownerId));
        return Promise.all([
            company.type === 'client'
                ? DeviceDetailsSectionHandler.getAvailableRootDeviceTypeIdsForClient(this.admin, this.ownerId)
                : DeviceDetailsSectionHandler.getAvailableRootDeviceTypeIdsForVendor(this.admin, this.ownerId),
            this.admin.getCached(`listDeviceTypes/${this.ownerId}`, api => api.entities.listDeviceTypes(this.ownerId)),
        ]).then(async ([available, deviceTypes]) => {

            const currentDeviceTypeId = entity && entity.deviceType && entity.deviceType.id;
            const deviceTypeValues = DeviceDetailsSectionHandler.filterAllowedDeviceTypes(this.ownerId, deviceTypes.items, available, [currentDeviceTypeId]) as FormBuilderKeyValue[];

            return [
                TextField('name', this.translate('FIELDS.NAME'), true, 1, 255),
                { ...ComboField('deviceType', this.translate('FIELDS.DEVICE_TYPE'), true, deviceTypeValues, IdNameComboValueHandlers), readonly: !this.creating },
            ].filter(x => x);
        }).then(fields => EntityUtils.prepareBulk(!entity, ['deviceType', 'provider'], fields));
    }


}
